<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 backdrop-blur-sm"
    >
      <div
        class="w-full max-w-sm rounded-2xl border border-secondary bg-primary p-6 text-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="duplicated-flyer-title"
      >
        <div class="flex flex-col items-center text-center">
          <div
            class="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-400/10 ring-1 ring-amber-400/40"
          >
            <IconCopy class="h-7 w-7 text-amber-400" stroke="1.75" />
          </div>
          <h2 id="duplicated-flyer-title" class="text-lg font-semibold">Cartela duplicada</h2>
          <p class="mt-1 text-sm text-muted-gray">Esta tag já foi apontada em outro produto.</p>
        </div>

        <div v-if="firstAttestation" class="mt-5 rounded-xl bg-secondary/60 p-4">
          <p class="text-[11px] font-semibold uppercase tracking-wider text-muted-gray">
            1º apontamento
          </p>
          <div class="mt-3 grid grid-cols-[1fr_auto] gap-4">
            <div class="min-w-0">
              <p class="flex items-center gap-1.5 text-xs text-muted-gray">
                <IconCalendarEvent class="h-3.5 w-3.5" stroke="2" />
                Data
              </p>
              <p class="mt-0.5 truncate text-sm font-semibold">{{ firstAttestation.date }}</p>
            </div>
            <div>
              <p class="flex items-center gap-1.5 text-xs text-muted-gray">
                <IconClipboardList class="h-3.5 w-3.5" stroke="2" />
                OP
              </p>
              <p class="mt-0.5 text-sm font-semibold">{{ firstAttestation.orderNumber }}</p>
            </div>
          </div>
        </div>
        <p v-else-if="fallbackMessage" class="mt-5 rounded-xl bg-secondary/60 p-4 text-sm text-quaternary">
          {{ fallbackMessage }}
        </p>

        <p class="mt-4 text-center text-xs leading-relaxed text-muted-gray">
          Ao confirmar, este produto entra como
          <span class="font-semibold text-white">não conformidade</span>.
        </p>

        <div class="mt-6 grid grid-cols-2 gap-3">
          <VButton type="outline" title="Cancelar" :callback="cancel" />
          <VButton type="solid" title="Confirmar" :callback="confirm" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { IconCalendarEvent, IconClipboardList, IconCopy } from '@tabler/icons-vue'
import VButton from '../Button/VButton.vue'

export type DuplicatedFlyerFirstAttestation = {
  date: string
  orderNumber: string | number
}

defineProps<{
  isOpen: boolean
  // Data e OP do 1º apontamento, vindos do backend (params do TagFromDuplicatedFlyerError)
  firstAttestation?: DuplicatedFlyerFirstAttestation | null
  // Usado só se o backend não mandar os params
  fallbackMessage?: string
}>()

const emit = defineEmits<{ confirm: []; cancel: [] }>()

async function confirm() {
  emit('confirm')
}

async function cancel() {
  emit('cancel')
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
